import { render } from "./ActiVite.vue?vue&type=template&id=23824d62&scoped=true&ts=true"
import script from "./ActiVite.vue?vue&type=script&lang=ts"
export * from "./ActiVite.vue?vue&type=script&lang=ts"

import "./ActiVite.vue?vue&type=style&index=0&id=23824d62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23824d62"]])

export default __exports__